export const Translations_HE = {
	footer: {
		join: "הצטרפו לשרשור עכשיו. אין צורך באפליקציה או בהרשמה.",
		climate: "שרשור ידידותי לסביבה.",
		tree: "שתלנו את העץ.",
		start: "צרו שרשור וידאו בחינם.",
	},
};
